
$(document).ready(function() {
  var elem = document.querySelector(".filtros-vue");
  if (elem == null) {
    return;
  }

  let vueAppFiltros = new Vue({
    el: elem,
    data: {
      lugarId: null,
      lugar: null,
      tipoEventoId: null,
      tipoEvento: null,
      fecha: null,

      langFecha: {
        formatLocale: {
          firstDayOfWeek: 1,
        },
        monthBeforeYear: true,
      },
      disabledDates: function _default(date) {
        const hoy = new Date();
        const hoyDespues6Meses = new Date(hoy);
        hoyDespues6Meses.setMonth(hoy.getMonth() + 6);

        return date < hoy || date > hoyDespues6Meses;
      },

      cargandoLugares: false,
      lugares: [],

      cargandoTiposEventos: false,
      tiposEventos: [],
    },
    computed: {
      fechaFormato: function (){
        if(this.fecha == null){
          return null;
        }
        return dayjs(this.fecha).format('YYYY-MM-DD')
      },
    },
    mounted() {
      try{
        if(window.location.search.length > 0){
          const searchParams = new URLSearchParams(window.location.search);
          const decodedParams = Array
            .from(searchParams.keys())
            .reduce((acc, key) => ({ ...acc, [key]: searchParams.get(key) }), {});
          if(decodedParams.fecha != null &&
            decodedParams.fecha != "null" &&
            decodedParams.fecha.length > 0){
            this.fecha = dayjs(decodedParams.fecha ).toDate();
          }
          if(decodedParams.lugar != null &&
            decodedParams.lugar != "null" &&
            decodedParams.lugar.length > 0){
            this.lugarId = decodedParams.lugar
          }
          if(decodedParams.tipo_evento_id != null &&
            decodedParams.tipo_evento_id != "null" &&
            decodedParams.tipo_evento_id.length > 0){
            this.tipoEventoId = decodedParams.tipo_evento_id
          }
        }
      }
      catch (error){
        ReportErrorLog(error)
        console.error(error)
      }

      this.getLugares();
      this.getTiposEventos();
    },
    methods: {
      getLugares(){
        if (this.cargandoLugares) {
          return
        }
        this.cargandoLugares = true
        axios
          .get("/ciudades-json")
          .then((respuesta) => {
            vueAppFiltros.cargandoLugares = false
            if (respuesta.data.error) {
              swal({
                icon: "info",
                title: respuesta.data.error,
                button: {
                  text: "Aceptar",
                  closeModal: true,
                },
              })
              return
            }
            vueAppFiltros.lugares = respuesta.data.ciudades.map(item => {
              return {code: item.nombre, label: item.nombre}
            });
            if(vueAppFiltros.lugarId != null){
              vueAppFiltros.lugar = vueAppFiltros.lugares.find(item => item.label == vueAppFiltros.lugarId)
            }

          })
          .catch((error) => {
            ReportErrorLog(error)
            console.error(error)
            vueAppFiltros.cargandoLugares = false
            swal({
              icon: "info",
              title: "Ocurrió un error inesperado",
              button: {
                text: "Aceptar",
                closeModal: true,
              },
            })
          })
      },
      getTiposEventos(){
        if (this.cargandoTiposEventos) {
          return
        }
        this.cargandoTiposEventos = true
        axios
          .get("/tipos-eventos-json")
          .then((respuesta) => {
            vueAppFiltros.cargandoTiposEventos = false
            if (respuesta.data.error) {
              swal({
                icon: "info",
                title: respuesta.data.error,
                button: {
                  text: "Aceptar",
                  closeModal: true,
                },
              })
              return
            }
            vueAppFiltros.tiposEventos = respuesta.data.tipos_eventos.map(item => {
              return {code: item.id, label: item.nombre, icono: item.imagen_thumb}
            });

            if(vueAppFiltros.tipoEventoId != null){
              vueAppFiltros.tipoEvento = vueAppFiltros.tiposEventos.find(item => item.code == vueAppFiltros.tipoEventoId)
            }
          })
          .catch((error) => {
            ReportErrorLog(error)
            console.error(error)
            vueAppFiltros.cargandoTiposEventos = false
            swal({
              icon: "info",
              title: "Ocurrió un error inesperado",
              button: {
                text: "Aceptar",
                closeModal: true,
              },
            })
          })
      }
    }
  });
});
